<template>
  <div class="login">
    <b-container>
      <b-row>
        <b-col md="7" lg="5">
          <div class="form-decorated">
            <loader v-if="isLoading" />

            <div class="errors" v-if="!!error">
              <b-alert v-for="(message, index) in error" show :key="`error-${index}`" variant="danger">
                {{ message }}
              </b-alert>
            </div>

            <b-form @submit.prevent="onSubmit" novalidate>
              <b-form-group id="username" label="Username" label-for="username">
                <b-form-input id="username" type="text" v-model="form.username" :state="getFieldState('username')" />

                <b-form-invalid-feedback>
                  Username is required
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="password" label="Password" label-for="password">
                <b-form-input id="password" type="password" v-model="form.password" :state="getFieldState('password')" />

                <b-form-invalid-feedback>
                  Password is required
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group>
                <router-link :to="{name: 'account-forgot-password'}">I forgot my password</router-link>
              </b-form-group>

              <b-button type="submit" class="btn-decorated">Log in</b-button>
            </b-form>
          </div>

          <social-login class="social-login" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import Loader from '@/components/widgets/Loader'
import SocialLogin from '@/components/widgets/SocialLogin'

export default {
  name: 'Login',
  components: {
    Loader,
    SocialLogin
  },
  data () {
    return {
      form: {
        username: '',
        password: '',
        next: this.$route.query.next
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      username: {
        required
      },
      password: {
        required
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoading', 'error'])
  },
  methods: {
    ...mapActions('auth', ['login']),

    getFieldState (name) {
      const field = this.$v.form[name]

      if (typeof field === 'undefined') {
        return null
      }

      if (field.$dirty && field.$error) {
        return false
      }

      return null
    },

    onSubmit (evt) {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.login(this.form)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

.login {
  margin: -48px -15px 0 -15px;
  padding-top: 48px;
  background-image: linear-gradient(to bottom, rgba(0,0,0,0) 57%, $body-bg),
                    url(/static/img/login-signup-bg.jpg);

  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  min-height: 90vh;

  .row {
    margin-top: 5em;
    margin-bottom: 5em;
  }
}

.form-decorated {
  margin: 3em;

  form {
    position: relative;
    z-index: 1;
  }

  .btn-decorated {
    position: absolute;
    left: calc(50% - 40px);
  }

  .errors {
    font-size: 0.8em;
  }
}

.social-login {
  margin: 0 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/account/Login.vue